import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorTradingVolume(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="13"
      height="14"
      ariaLabel="Trading Volume Icon"
    >
      <path
        fill={`url(#${id})`}
        d="M11.5884 6.74394C11.9419 6.74394 12.2335 7.00841 12.2763 7.35025L12.2817 7.43721V12.8293C12.2817 13.2122 11.9713 13.5225 11.5884 13.5225C11.235 13.5225 10.9434 13.2581 10.9006 12.9162L10.8952 12.8293V7.43721C10.8952 7.05433 11.2056 6.74394 11.5884 6.74394ZM6.96666 8.28453C7.32009 8.28453 7.61174 8.54901 7.65452 8.89084L7.65993 8.9778V12.8293C7.65993 13.2122 7.34954 13.5225 6.96666 13.5225C6.61323 13.5225 6.32157 13.2581 6.27879 12.9162L6.27339 12.8293V8.9778C6.27339 8.59492 6.58378 8.28453 6.96666 8.28453ZM2.34488 9.82513C2.69831 9.82513 2.98997 10.0896 3.03275 10.4314L3.03815 10.5184V12.8293C3.03815 13.2122 2.72776 13.5225 2.34488 13.5225C1.99145 13.5225 1.69979 13.2581 1.65702 12.9162L1.65161 12.8293V10.5184C1.65161 10.1355 1.962 9.82513 2.34488 9.82513ZM12.2073 0.501434C12.5152 0.501434 12.7743 0.729465 12.8158 1.03704L12.8209 1.11502V5.13917C12.8209 5.47811 12.5462 5.75295 12.2073 5.75295C11.8995 5.75295 11.6404 5.52481 11.5988 5.21731L11.5937 5.13939L11.5931 2.60822L8.18683 6.00328C7.99434 6.19466 7.70384 6.23426 7.4676 6.11036L7.39108 6.06298L7.32009 6.00224L6.19713 4.87983L1.85639 9.22153C1.76329 9.31481 1.6449 9.37392 1.51854 9.39384L1.42254 9.40134C1.26085 9.40134 1.10513 9.33818 0.988743 9.22161C0.775216 9.00828 0.749512 8.67233 0.927934 8.42497L0.988718 8.35396L5.76406 3.57859C5.97752 3.36513 6.31312 3.33951 6.56059 3.51781L6.63169 3.57859L7.75467 4.70189L10.7388 1.72777L8.18315 1.72861C7.90323 1.72861 7.66368 1.54015 7.59123 1.2748L7.57464 1.193L7.56957 1.11502C7.56957 0.807102 7.7976 0.548047 8.10517 0.506506L8.18315 0.501434H12.2073Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="12.8209"
          y1="8.05833"
          x2="0.809583"
          y2="8.07055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2b6aff" />
          <stop offset="1" stopColor="#39d0d8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
